function ExportCSVButton({handleExportCSV}) { 
    return (
        <>
            <div className="d-flex justify-content-around">
                <button className="el-main-button" onClick={handleExportCSV}> <span> <i className="el-icon-download"></i> Export CSV</span> </button>
            </div>
        </>
    );
}  
export default ExportCSVButton;